import React from 'react';
import { TablePagination, TablePaginationProps } from '@mui/material';

interface CommonTablePaginationProps extends Omit<TablePaginationProps, 'component' | 'rowsPerPageOptions' | 'labelRowsPerPage' | 'labelDisplayedRows'> {
  rowsPerPageOptions?: number[];
  labelDisplayedRowsFormat?: 'default' | 'detailed';
}

/**
 * 共通のTablePaginationコンポーネント
 * アプリケーション全体で統一された表示形式を提供
 */
const CommonTablePagination: React.FC<CommonTablePaginationProps> = ({
  rowsPerPageOptions = [ 20, 50, 100 ],
  labelDisplayedRowsFormat = 'default',
  ...props
}) => {
  const getLabelDisplayedRows = ({ from, to, count }: { from: number; to: number; count: number }) => {
    if (labelDisplayedRowsFormat === 'detailed') {
      return `${count}件中 ${from}-${to}件を表示`;
    }
    // デフォルトフォーマット
    return `${from}-${to} / ${count !== -1 ? count : `${to}以上`}`;
  };
  return (
    <TablePagination
      component="div"
      rowsPerPageOptions={rowsPerPageOptions}
      labelRowsPerPage="表示件数:"
      labelDisplayedRows={getLabelDisplayedRows}
      {...props}
    />
  );
};
export default CommonTablePagination;
